/**
 * "Recommended services" on a member's profile (docs/MarketplaceDesign.md
 * section 3.8, D68 item 4): the vendors the member recommends in the active
 * organization. Each links to the vendor page with the recommender attached
 * (`?ref=`), and says "May earn a referral reward" when the vendor's program
 * pays one (CR-36).
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as marketApi from '../api/marketplace';
import { useOrg } from '../lib/org';
import VendorLogo from './VendorLogo';
import { cn, ui } from '../lib/ui';

export default function RecommendedServices({ userId }) {
  const { activeOrg } = useOrg();
  const [recs, setRecs] = useState(null);

  useEffect(() => {
    if (!activeOrg) return undefined;
    let live = true;
    marketApi
      .listRecommendations(userId)
      .then(d => live && setRecs(d.recommendations))
      .catch(() => live && setRecs([]));
    return () => {
      live = false;
    };
  }, [userId, activeOrg]);

  if (!activeOrg || !recs || recs.length === 0) return null;
  return (
    <section aria-labelledby="recommended-services-heading" className="mt-8">
      <h2 id="recommended-services-heading" className={ui.h2}>
        Recommended services
      </h2>
      <ul className={cn(ui.grid, ui.gridMd2, 'm-0 list-none p-0')}>
        {recs.map(r => (
          <li key={r.vendorId} className={cn(ui.cardFlat, 'flex items-center gap-3')}>
            <VendorLogo
              vendor={{ businessName: r.vendorName, logoUrl: r.logoUrl }}
              size="size-10"
            />
            <span>
              <Link
                to={`/marketplace/vendors/${encodeURIComponent(r.vendorId)}?ref=${encodeURIComponent(r.userId)}`}
              >
                {r.vendorName}
              </Link>
              {r.mayEarn && (
                <span className={cn(ui.hint, 'block')}>May earn a referral reward</span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
